module.exports = __webpack_public_path__ + "img/real-madrid.f77b75c7.png";